export default __webpack_public_path__ + "static/media/greeting6.31a9ed87.svg";